import React from 'react'

/** Контекст выбранной конфигурации. configId — ID конфига при редактировании. */
export const ConfigContext = React.createContext({ configId: null })

export function ConfigProvider({ configId, children }) {
  return <ConfigContext.Provider value={{ configId }}>{children}</ConfigContext.Provider>
}

export function useConfigId() {
  return React.useContext(ConfigContext)?.configId ?? null
}
